import Spinner from '../indicators/Spinner';

export const FileLoadingSpinner = () => {
  return <Spinner className="stroke-border-base-back-3 p-2" />;
};

